__turbopack_context__.v({
  "className": "cairo_a334409d-module__Bj7z8q__className",
  "variable": "cairo_a334409d-module__Bj7z8q__variable",
});
